module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"placeholder":"Placeholder (optional)"}},"de":{"label":{"placeholder":"Platzhalter (optional)"}},"fr":{"label":{"placeholder":"Texte de remplacement (facultatif)"}},"it":{"label":{"placeholder":"Segnaposto (opzionale)"}}}')
  delete Component.options._Ctor
}
